import OrchestratorAPI from './common.js';
import {
  type ApiInstanceField,
  type ApiInstanceFieldWithTypeAndName,
} from '../models/orchestrator/apiInstanceField.js';
import { type SetValues } from '../models/orchestrator/instanceField.js';

type FindForApiInstanceSearch =
  | {
      canonicalFieldId: string;
    }
  | {
      canonicalFieldTypeName: string;
      canonicalFieldValue?: string;
    }
  | {
      canonicalFieldTypeName: string;
      apiInstanceFieldValue?: string;
    };

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/api-instance-fields';

  async findForApiInstance(
    apiInstanceId: string,
    searchQuery?: FindForApiInstanceSearch
  ): Promise<ApiInstanceFieldWithTypeAndName[]> {
    const url = this.constructPath(`/api-instances/${apiInstanceId}`, searchQuery);
    const { apiInstanceFields } = await this.common.getJSON(url);
    return apiInstanceFields.map(this.deserialize);
  }

  async setForApiInstance(args: {
    apiInstanceId: string;
    canonicalFieldTypeId: string;
    values: SetValues[];
  }): Promise<ApiInstanceField[]> {
    const { apiInstanceId, canonicalFieldTypeId, values } = args;

    const url = this.constructPath(
      `/api-instances/${apiInstanceId}/canonical-field-types/${canonicalFieldTypeId}`
    );
    const { apiInstanceFields } = await this.common.postJSON(url, values);
    return apiInstanceFields.map(this.deserialize);
  }
}
